import Noadmin from '../components/Noadmin/Noadmin';

const GuestRoutes = [
	{
		collapse: false,
		path: "/",
		name: {
			"ru": "Главная",
			"en": "Main",
			"sk": "Hlavná"
		},
		state: "home",
		icon: "mdi mdi-home",
	},
	{
		collapse: false,
		path: "/dashboard/noadmin",
		name: {
			"ru": "Маркет",
			"en": "Market",
			"sk": "Trhové",
		},
		state: "market",
		icon: "mdi mdi-apps",
		component: Noadmin,
		// child: [
		// 	{
		// 		path: "/market",
		// 		name: "Маркет",
		// 		mini: "B",
		// 		icon: "mdi mdi-apps",
		// 		component: Market
		// 	},
		// 	{
		// 		path: "/market/add",
		// 		name: "Загрузка приложения",
		// 		mini: "B",
		// 		icon: "mdi mdi-upload",
		// 		component: UploadApk
		// 	},
		// 	{
		// 		path: "/market/app",
		// 		name: "Настройка приложения",
		// 		mini: "B",
		// 		icon: "mdi mdi-border-color",
		// 		component: Apk
		// 	},
		// ]
	},

];
export default GuestRoutes;



// WEBPACK FOOTER //
// ./src/routes/guestRoutes.js